"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modifyDomain = void 0;
var modifyDomain = function modifyDomain(domain) {
  if (typeof window !== 'undefined') {
    var host = window.location.hostname || '';
    var match = host.match(/(\.uhg\.com|\.uhc\.com|\.optum\.com)/);
    if (match) {
      return domain.replace('.uhg.com', match[0]);
    }
  }
  return domain;
};
exports.modifyDomain = modifyDomain;